export default __webpack_public_path__ + "static/media/blog-post-layout-03-img-15.3ce3d93c.jpg";